import React from 'react';

import * as Styles from './ContainerBG.styles';

const ContainerBG = ({ children, image, alt, ...props }) => {
  return (
    <Styles.Container {...props}>
      <Styles.BgContainer>
        <Styles.BgImage
          image={image}
          objectFit={props.objectFit ? props.objectFit : 'cover'}
          objectPosition={
            props.objectPosition ? props.objectPosition : 'center center'
          }
          alt={alt ? alt : ''}
        />
      </Styles.BgContainer>
      <Styles.BgContent>{children}</Styles.BgContent>
    </Styles.Container>
  );
};

export default ContainerBG;
